/* eslint-disable  */

(function (Drupal, $) {
  Drupal.behaviors.on_this_page = {
    attach: function (context) {
      $(function () {
        var sectionList = [];

        $('.in-page-nav')
          .closest('.padding-horizontal')
          .parent()
          .find('H2:not(.dont-show)')
          .once()
          .each(function () {
            sectionList.push($(this));
          });

        $('.in-page-nav__list')
          .once()
          .each(function () {
            if (sectionList.length > 0) {
              for (let i = 0; i < sectionList.length; i++) {
                var elem = sectionList[i];
                elem.attr('id', 'referenced-section-' + (i + 1));
                $(this).append('<li><a href="#referenced-section-' + (i + 1) + '">' + elem.text() + '</a></li>');
              }
            } else {
              $('.content-page').removeClass('has-in-page-nav');
              $(this).closest('.in-page-nav').remove();
            }
          });
      });
    },
  };
})(Drupal, jQuery);
